import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import { FaMapMarkerAlt, FaMicrosoft, FaBed, FaCarAlt, FaHome, FaCheckCircle, FaCross, FaTimes } from "react-icons/fa";
import { useParams, useHistory } from 'react-router-dom';
import Background from './Background';
import { useState, useEffect, useRef } from 'react';
import './TableStyle.css';
import { MapContainer, TileLayer } from 'react-leaflet';
import { useNavigate } from 'react-router-dom';

function ChatDetails() {
    const { sender_id } = useParams();
    const { receiver_id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [chatDetails,setChatDetails] = useState(null);
    const [userInfo, setUserInfo] = useState(null);
    const [message, setMessage] = useState("");
    const history = useHistory();
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }

    const getUserInfo = () => {
        const userId = sender_id != 11 ? sender_id : receiver_id;
        console.log('Fetching user info for userId:', userId);
        var data = new FormData();
        data.append("id", userId);
        
        fetch('https://api.connecker.com/api/get_user_by_id', {
            method: 'POST',
            body: data
        }).then(res => {
            if(!res.ok) {
                throw Error('Could not fetch user info');
            }
            return res.json();
        }).then(data => {
            console.log('User info response:', data);
            if(data.response_code == 200) {
                setUserInfo(data.data);
            }
        }).catch(error => {
            console.error('Error fetching user info:', error);
        });
    }

    const getUserInfoFromChat = () => {
        if (chatDetails && chatDetails.length > 0) {
            // Find a message from the user (not admin)
            const userMessage = chatDetails.find(chat => chat.sender_id != 11);
            if (userMessage && userMessage.user) {
                console.log('Using user info from chat:', userMessage.user);
                setUserInfo(userMessage.user);
            }
        }
    }

    const getMessages = () => {
        var data = new FormData();
        data.append("sender_id",sender_id);
        data.append("receiver_id",receiver_id);
        setIsLoading(true);
        fetch('https://api.connecker.com/api/get_messages', {
            method: 'POST',
            body: data
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
         }).then(async(data) => {
            setIsLoading(false);
            if(data.response_code == 200) {
                if(chatDetails != null) {
                	if(chatDetails.length != data.data.length) {
	         		scrollToBottom();
			}
                }
                setChatDetails(data.data);
                
                // Try to get user info from chat data if not already set
                if (!userInfo && data.data && data.data.length > 0) {
                    const userMessage = data.data.find(chat => chat.sender_id != 11);
                    if (userMessage && userMessage.user) {
                        console.log('Setting user info from chat messages:', userMessage.user);
                        setUserInfo(userMessage.user);
                    }
                }
            } else if(data.response_code == 404) {
                setChatDetails({});
            }
         });
    }


        

const handleXButtonClick = () => {
    history.push('/chat_list');
}

    const sendMessage = () => {
        var data = new FormData();
        data.append("sender_id",11);
        if(sender_id != 11) {
            data.append("receiver_id",sender_id);
        } else {
            data.append("receiver_id",receiver_id);
        }
        data.append("message",message);
        setIsLoading(true);
        fetch('https://api.connecker.com/api/send_message', {
            method: 'POST',
            body: data
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            setMessage("");
            return res.json();
         }).then(async(data) => {
            setIsLoading(false);
            if(data.response_code == 200) {
                setChatDetails(data.data);
                scrollToBottom();
            } else if(data.response_code == 404) {
                setChatDetails({});
            }
         });
    }

    useEffect(() => {
        const abortController = new AbortController();
        getUserInfo();
        getMessages();
        setInterval(() => {
            getMessages();
        }, 9000);
    },[]);

    // Effect to get user info from chat when chatDetails changes
    useEffect(() => {
        if (!userInfo) {
            getUserInfoFromChat();
        }
    }, [chatDetails]);

    return(
        <div className="content">
            <div className="row justify-content-start">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: "40px" }}>
                        <Background></Background>
                        
                        <h4 className="heading" style={{ color:"white", marginTop:"50px", marginBottom: "30px" }}>Chat</h4>
                        
                        {/* Modern Chat Container */}
                        <div className="card shadow-lg" style={{
                            width:"100%", 
                            height: "calc(100vh - 200px)",
                            borderRadius: "15px",
                            border: "none",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column"
                        }}>
                            
                            {/* Chat Header */}
                            <div style={{
                                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                padding: "20px",
                                color: "white",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderBottom: "1px solid #e0e0e0"
                            }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        backgroundColor: "rgba(255,255,255,0.2)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: "15px",
                                        overflow: "hidden",
                                        border: "2px solid rgba(255,255,255,0.3)"
                                    }}>
                                        {userInfo?.profile_pic ? (
                                            <img 
                                                src={userInfo.profile_pic}
                                                alt="Profile"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover"
                                                }}
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.nextSibling.style.display = 'flex';
                                                }}
                                            />
                                        ) : null}
                                        <span style={{ 
                                            fontSize: "18px", 
                                            fontWeight: "600",
                                            display: userInfo?.profile_pic ? "none" : "flex"
                                        }}>
                                            {userInfo?.first_name ? userInfo.first_name.charAt(0).toUpperCase() : 'U'}
                                        </span>
                                    </div>
                                    <div>
                                        <h6 style={{ margin: "0", fontWeight: "600" }}>
                                            {userInfo ? `${userInfo.first_name || ''} ${userInfo.last_name || ''}`.trim() || 'User Chat' : 'User Chat'}
                                        </h6>
                                        <small style={{ opacity: "0.9" }}>
                                            {userInfo?.email || 'Online'}
                                        </small>
                                    </div>
                                </div>
                                <button 
                                    onClick={() => handleXButtonClick()} 
                                    style={{
                                        background: "rgba(255,255,255,0.1)",
                                        border: "none",
                                        borderRadius: "50%",
                                        width: "35px",
                                        height: "35px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease"
                                    }}
                                    onMouseOver={(e) => e.target.style.background = "rgba(255,255,255,0.2)"}
                                    onMouseOut={(e) => e.target.style.background = "rgba(255,255,255,0.1)"}
                                >
                                    <FaTimes size={14} />
                                </button>
                            </div>
                            
                            {/* Chat Messages Area */}
                            <div style={{
                                flex: 1,
                                padding: "20px",
                                overflowY: "auto",
                                backgroundColor: "#f8f9fa",
                                display: "flex",
                                flexDirection: "column",
                                gap: "15px"
                            }}>
                                {chatDetails != null ? chatDetails.map((chat, i) => (
                                    <div key={i} style={{
                                        display: "flex",
                                        justifyContent: chat.sender_id == 11 ? "flex-end" : "flex-start",
                                        marginBottom: "10px"
                                    }}>
                                        {chat.sender_id == 11 ? (
                                            // Admin Messages (Right)
                                            <div style={{
                                                maxWidth: "70%",
                                                padding: "12px 18px",
                                                borderRadius: "20px 20px 5px 20px",
                                                backgroundColor: "#007bff",
                                                color: "white",
                                                fontSize: "14px",
                                                lineHeight: "1.4",
                                                boxShadow: "0 2px 8px rgba(0,123,255,0.2)",
                                                wordWrap: "break-word"
                                            }}>
                                                {chat.message}
                                                <div style={{
                                                    fontSize: "11px",
                                                    opacity: "0.8",
                                                    marginTop: "5px",
                                                    textAlign: "right"
                                                }}>
                                                    Admin
                                                </div>
                                            </div>
                                        ) : (
                                            // User Messages (Left)
                                            <div style={{
                                                maxWidth: "70%",
                                                padding: "12px 18px",
                                                borderRadius: "20px 20px 20px 5px",
                                                backgroundColor: "white",
                                                color: "#333",
                                                fontSize: "14px",
                                                lineHeight: "1.4",
                                                border: "1px solid #e0e0e0",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                wordWrap: "break-word"
                                            }}>
                                                {chat.message}
                                                <div style={{
                                                    fontSize: "11px",
                                                    color: "#666",
                                                    marginTop: "5px"
                                                }}>
                                                    User
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )) : (
                                    <div style={{
                                        textAlign: "center",
                                        color: "#666",
                                        fontSize: "14px",
                                        fontStyle: "italic"
                                    }}>
                                        No messages yet. Start the conversation!
                                    </div>
                                )}
                                <div ref={messagesEndRef} />
                            </div>
                            
                            {/* Message Input Area */}
                            <div style={{
                                padding: "20px",
                                backgroundColor: "white",
                                borderTop: "1px solid #e0e0e0",
                                display: "flex",
                                alignItems: "center",
                                gap: "15px"
                            }}>
                                <input 
                                    type="text"
                                    style={{
                                        flex: 1,
                                        border: "2px solid #e0e0e0",
                                        borderRadius: "25px",
                                        padding: "12px 20px",
                                        fontSize: "14px",
                                        outline: "none",
                                        transition: "all 0.3s ease"
                                    }}
                                    onChange={(e) => setMessage(e.target.value)}
                                    placeholder="Type your message..."
                                    value={message}
                                    onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
                                    onFocus={(e) => e.target.style.borderColor = "#007bff"}
                                    onBlur={(e) => e.target.style.borderColor = "#e0e0e0"}
                                />                           
                                <button 
                                    onClick={sendMessage}
                                    disabled={!message.trim()}
                                    style={{
                                        background: message.trim() ? "linear-gradient(135deg, #007bff 0%, #0056b3 100%)" : "#ccc",
                                        border: "none",
                                        borderRadius: "50%",
                                        width: "50px",
                                        height: "50px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white",
                                        cursor: message.trim() ? "pointer" : "not-allowed",
                                        transition: "all 0.3s ease",
                                        boxShadow: message.trim() ? "0 4px 12px rgba(0,123,255,0.3)" : "none"
                                    }}
                                    onMouseOver={(e) => {
                                        if (message.trim()) {
                                            e.target.style.transform = "scale(1.05)";
                                        }
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.transform = "scale(1)";
                                    }}
                                >
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M2,21L23,12L2,3V10L17,12L2,14V21Z" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    )
}

export default ChatDetails;
